module.exports = __webpack_public_path__ + "img/playstore.468ef7f5.png";